module.exports = __webpack_public_path__ + "media/images/chaise haute-ea299266f80a475e138371d28b446940.svg";